// slide03
var paginationText02 = $(".slide03 .pagination_text li");
var slide02 = new Swiper(".slide03", {
    loop: true,
    slidesPerView: 1,
    navigation: {
        nextEl: '.slide03 .swiper-button-next',
        prevEl: '.slide03 .swiper-button-prev',
    },
    pagination: {
        el: ".slide03 .swiper-pagination",
        clickable: true,
        bulletActiveClass : 'on',
        renderBullet: function (index, className) {
            return '<p class="' + className + '"><span>' + (paginationText02.eq(index).text()) + '</span></p>';
        },
    },
});